import styled from "styled-components";
import { ReactComponent as CrossIcon } from "../../assets/cross_icon.svg";
import { BASIC_YELLOW } from "../../constants/colors";

type Props = {
  onCancel: () => void;
};

export const MenuReorderHeader: React.FC<Props> = ({ onCancel }) => {
  return (
    <MenuReorderHeaderContainer>
      <MenuReorderText>同じものを注文する</MenuReorderText>

      <MenuReorderButton onClick={onCancel}>
        <MenuReorderText>キャンセル</MenuReorderText>

        <MenuReorderClose>
          <CrossIcon />
        </MenuReorderClose>
      </MenuReorderButton>
    </MenuReorderHeaderContainer>
  );
};

const MenuReorderHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${BASIC_YELLOW};
  padding: 14px;
`;

const MenuReorderText = styled.div`
  margin: 0px;
  font-size: 16px;
  font-weight: 200;
`;

const MenuReorderButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 200;
  cursor: pointer;
`;

const MenuReorderClose = styled.div`
  width: 10px;
  margin-left: 5px;
`;
